import styled from '@emotion/styled'

const DetailsContainer = styled.div`
	${({ theme }) => `
	    display: flex;
	    gap: 24px;
        background: ${theme.palette.background.paper};
        border-radius: 8px;
        padding: 30px 24px;

        .key-value-container {
        	padding-bottom: 24px;

			&:last-child {
				padding-bottom: 0;
			}
        }
    `}
`

const DetailsSubContainer = styled.div`
	flex: 1;
`

const DetailsTitle = styled.div`
	${({ theme }) => `
	    font-size: 1rem;
	    font-weight: 600;
	    color: ${theme.palette.text.primary};
	    padding-top: 16px;
	    padding-bottom: 16px;
    `}
`

const DetailsSubtitle = styled.div`
	${({ theme }) => `
	    font-size: 0.875rem;
	    font-weight: 600;
	    color: ${theme.palette.text.primary};
	    padding-bottom: 12px;
    `}
`

const DetailsSpacer = styled.div`
	${({ theme }) => `
	    width: 50%;
		margin-bottom: 24px;
		border-bottom: 1px solid ${theme.palette.borderColors.darkGray};
    `}
`

export {
	DetailsContainer,
	DetailsSpacer,
	DetailsSubContainer,
	DetailsSubtitle,
	DetailsTitle,
}
